<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"BUTTON.VIEW" | translate}} Questions</h5>
        <div class="edit-icons" (click)="onCancel()" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center">
        <div class="mt-3 mt-lg-4 mb-4 ms-auto">
            <button mat-raised-button color="primary" class="auth-form-btn ex-btn" type="submit" *ngIf="!isExpandAll" (click)="onExpandAll()">
                <img class="me-2" src="assets/images/icons/expand-all.svg" alt=""> Expand All</button>
            <button mat-raised-button color="primary" class="auth-form-btn ex-btn" type="submit" *ngIf="isExpandAll" (click)="onExpandAll()">
                <img class="me-3" src="assets/images/icons/collapse-all.svg" alt="">Collapse All</button>
        </div>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngFor="let item of questionArr;let i=index" [expanded]="isExpandAll">
            <mat-expansion-panel-header class="ti-box medium-sans">
                <mat-panel-title class="se-b d-flex medium-sans">
                    <div class="num-box me-2 ">{{i+1}}.</div>
                    <div class="panel-title">{{item.question}}</div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="template-content-box pb-2">
                <div class="item-box d-flex ">
                    <div class="d-flex justify-content-between pt-4 w-100">
                        <div class="d-flex align-items-center "> {{item.ans}}</div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>